import _ from "lodash";

import {isAddonPriceRequired} from "./methods";
import {moduleNamespace as dashboardModuleNamespace} from '../stripeConnectDashboard';
import {moduleNamespace as productManagerModuleNamespace} from '../productManager/constants';

/**
 * Key the user-created addon prices by their stripe_id.
 */
export function addonsByStripeId(state, getters) {
  let addonsByStripeId = {};
  const { prices: softwarePrices } = getters.softwareProduct;

  // TODO: Can this be refined?
  _.forEach(state.resaleAddons, resaleAddon => {
    _.forEach(resaleAddon.prices, resaleAddonPriceGroup => {
      _.forEach(resaleAddonPriceGroup, individualPrice => {

        if (isAddonPriceRequired(getters.supportedCurrencies, softwarePrices, individualPrice)) {
          const { stripe_id, price, name, ...simplifiedPrice } = individualPrice;
          if (state.addons[individualPrice.stripe_id] !== undefined) {
            addonsByStripeId[individualPrice.stripe_id] = {
              price: state.addons[individualPrice.stripe_id],
              ...simplifiedPrice,
            };
          }
        }

      });
    });
  });

  return addonsByStripeId;
}

/**
 * All addon prices, flattened to an array.
 *
 * Input:
 * addon: {
 *   addonName: [price1, price2, price3],
 *   addonName2: [price4, price5, price6],
 * }
 *
 * Output:
 * [price1, price2, price3, price4, ...etc]
 */
export function flattenResaleAddonPrices(resaleAddons) {
  return resaleAddons.reduce((addonReducer, addon) => {
    const flattenedAddon = Object.values(addon.prices).reduce((priceGroupReducer, priceGroup) => {
      return [...priceGroupReducer, ...priceGroup];
    }, []);
    return [...addonReducer, ...flattenedAddon];
  }, []);
}

/**
 * Flatten the resellable addons (above) and key by their stripe_id.
 */
export function resaleAddonPricesByStripeId({resaleAddons}) {
  return flattenResaleAddonPrices(resaleAddons)
    .reduce((pricesById, addonPrice) => {
      const { stripe_id, price, ...simplifiedPrice } = addonPrice;
      pricesById[stripe_id] = simplifiedPrice;
      return pricesById;
    }, {});
}

export default {
  addonsByStripeId,
  resaleAddonPricesByStripeId,
  softwareProduct: (state, getters, rootState, rootGetters) => {
    return rootGetters[`${productManagerModuleNamespace}/softwareProduct`];
  },
  supportedCurrencies: (state, getters, rootState, rootGetters) => {
    return rootGetters[`${productManagerModuleNamespace}/supportedCurrencies`];
  },
  resaleAddons: ({resaleAddons}) => resaleAddons,
  // TODO: Consider renaming everything to distinguish between Hike and User-Created
  addons: ({addons}) => addons,
  errors: ({errors}) => errors,
  missingAddonPrices: (state, getters, rootState, rootGetters) => {
    let result = false;
    const softwareProduct = rootGetters[`${dashboardModuleNamespace}/products`][0] ?? null;
    if (!softwareProduct) {
      return result;
    }
    const addonProducts = rootGetters[`${dashboardModuleNamespace}/addons`];

    const enabledCurrencies = rootGetters[`${dashboardModuleNamespace}/companyInfo`].enabledCurrencies;

    const enabledBillingPeriods = [];
    Object.keys(softwareProduct?.prices).forEach((currency) => {
      softwareProduct.prices[currency].forEach((price) => {
        if (!enabledBillingPeriods.includes(price.billing_period)) {
          enabledBillingPeriods.push(price.billing_period);
        }
      });
    });

    addonProducts.forEach((addon) => {
      // Check all enabled currencies are added for addons
      const addonCurrencies = Object.keys(addon.prices);
      const missingCurrency = !enabledCurrencies.every(
        currency => addonCurrencies.includes(currency)
      );
      result = result ? result : missingCurrency;

      Object.keys(addon.prices).forEach((currency) => {
        const addonBillingPeriods = addon.prices[currency].map((price) => price.billing_period);
        if (!addonBillingPeriods.includes('ONCE')) {
          const missingBillingPeriod = !enabledBillingPeriods.every(
            period => addonBillingPeriods.includes(period)
          );
          result = result ? result : missingBillingPeriod;
        }
      });
    });

    return result;
  },
};
